import { t } from "i18next";
import DBModal from "../../../../component/global/DBModal";
import DBInput from "../../../../component/global/DBInput";
import DBModalTitle from "../../../../component/global/DbModalTitle";
import DBFieldBlock from "../../../../component/global/DBFieldBlock";
import TreeSearchSelect from "./../../../../component/global/TreeSearchSelect/index";
import DBSelect from "../../../../component/global/DBSelect";
import DBButton from "../../../../component/global/DBButton";
import DBTextArea from "../../../../component/global/DBTextArea";
import { useContext, useEffect, useRef, useState } from "react";
import { useRequest } from "../../../../hooks/helperData/useRequest";
import {
    GET_AUTOMATION_GROUP_LIST,
    SETTING_FEATURES,
    SETTING_ITEMS_TYPE,
    SETTING_ITEMS_TYPE_FAETURES,
    SETTING_ITEMS_TYPE_TREE,
} from "../../../../helperData/ApiAddress";
import DBSpinner from "../../../../component/global/DBSpinner";
import DBAddButton from "../../../../component/global/DBAddButton";
import { ToastContext } from "../../../../component/global/ToastContext";
import DBSwitch from "./../../../../component/global/DBSwitch/index";
import {
    featureTypeList,
    getLanguageCaption,
    toBase64,
} from "../../../../feedback/helperFunctions";
import LanguageTable from "./LanguageTable";
import DBUpload from "./../../../../component/global/DBUpload/index";
import StateLanguageTable from "./StateLanguageTable";

export default function CriteriaStateModal({
    show,
    onHide,
    onSuccess,
    editMode,
    itemType,
    stateType,
}) {
    const toast = useContext(ToastContext);

    const [form, setForm] = useState({
        id: undefined,
        name: "",
        emoji: "",
        value: "0",
        translates: [],
    });

    const [formErr, setFormErr] = useState({
        name: "",
        emoji: "",
        value: "",
    });

    useEffect(() => {
        if (show) {
            if (editMode) {
                setForm({
                    id: editMode.id,
                    name: editMode.name,
                    emoji: editMode.emoji,
                    value: editMode.value + "",
                    translates: editMode.translates,
                });
            } else {
                setForm({
                    id: undefined,
                    name: "",
                    emoji: "",
                    value: "0",
                    translates: [],
                });
            }

            setFormErr({
                name: "",
                emoji: "",
                value: "",
            });
        }
    }, [show]);

    const [language, setLanguage] = useState({
        name: "",
        description: "",
        language: "en",
    });
    const [languageEditMode, setLanguageEditMode] = useState(false);

    const addLanguageHandle = () => {
        if (languageEditMode !== false) {
            setForm({
                ...form,
                translates: form.translates.map((item, index) =>
                    index === languageEditMode ? language : item
                ),
            });
            setLanguageEditMode(false);
            setLanguage({
                name: "",
                description: "",
                language: "en",
            });
        } else {
            if (
                !form.translates.some(
                    (item) => item.language === language.language
                )
            ) {
                setForm({
                    ...form,
                    translates: [...form.translates, language],
                });
                setLanguage({
                    name: "",
                    description: "",
                    language: "en",
                });
            }
        }
    };

    const deleteLanguageHandle = (index) => {
        setForm({
            ...form,
            translates: form.translates.filter((_, ind) => ind !== index),
        });
    };

    const editLanguageHandle = (index) => {
        setLanguage(form.translates.find((_, ind) => ind === index));
        setLanguageEditMode(index);
    };

    const addEditState = () => {
        let formErrTemp = { name: "", emoji: "", value: "" };

        if (form.name.trim() === "") {
            formErrTemp = {
                ...formErrTemp,
                name: t("criteria.state.name.err"),
            };
        }
        if (form.value.trim() === "") {
            formErrTemp = {
                ...formErrTemp,
                value: t("criteria.state.value.err"),
            };
        }
        if (Number(stateType) === 3 && form.emoji.trim() === "") {
            formErrTemp = {
                ...formErrTemp,
                emoji: t("criteria.state.emoji.err"),
            };
        }

        setFormErr(formErrTemp);

        if (formErrTemp.name || formErrTemp.emoji || formErrTemp.value)
            return false;

        onSuccess(form);
        onHide();
    };

    return (
        <DBModal
            permanent
            show={show}
            minWidth={560}
            onHide={onHide}
            className="criteria-state-modal"
        >
            <DBModal.Header
                closeBtn={onHide}
                title={t("criteria.state.header")}
            />

            <DBModal.Content>
                <DBModalTitle>{t("item.type.main.fields")}</DBModalTitle>
                <div className="grid">
                    <DBFieldBlock
                        title={t("criteria.state.name")}
                        required
                        error={formErr.name}
                    >
                        <DBInput
                            onClick={() => setFormErr({ ...formErr, name: "" })}
                            status={formErr.name && "error"}
                            type="text"
                            size="large"
                            value={form.name}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    name: e.target.value,
                                })
                            }
                        />
                    </DBFieldBlock>
                    <DBFieldBlock
                        title={t("criteria.state.value")}
                        required
                        error={formErr.value}
                    >
                        <DBInput
                            onClick={() =>
                                setFormErr({ ...formErr, value: "" })
                            }
                            status={formErr.value && "error"}
                            type="text"
                            size="large"
                            value={form.value}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    value: e.target.value,
                                })
                            }
                        />
                    </DBFieldBlock>
                    {Number(stateType) === 3 && (
                        <DBFieldBlock
                            title={t("criteria.state.emoji")}
                            required
                            error={formErr.emoji}
                        >
                            <DBUpload
                                type={
                                    formErr.emoji || form.emoji
                                        ? "secondary"
                                        : "primary"
                                }
                                accept=".svg,.png"
                                maxSize={20 * 1024}
                                outlined
                                caption={
                                    form.emoji
                                        ? t("remove.emoji.image")
                                        : t("add.emoji.image")
                                }
                                onClick={(e) => {
                                    {
                                        setFormErr({ ...formErr, emoji: "" });

                                        if (form.emoji) {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            setForm({
                                                ...form,
                                                emoji: "",
                                            });
                                        }
                                    }
                                }}
                                onChange={(e) => {
                                    e.target.files[0] &&
                                        toBase64(e.target.files[0]).then(
                                            (base64) => {
                                                console.log(
                                                    `<img src="${base64}" alt="emoji" />`
                                                );
                                                setForm({
                                                    ...form,
                                                    emoji: `<img src="${base64}" alt="emoji" />`,
                                                });
                                            }
                                        );
                                }}
                            />
                        </DBFieldBlock>
                    )}
                </div>
                <DBModalTitle>{t("items.language")}</DBModalTitle>
                <div className="grid">
                    <DBFieldBlock title={t("criteria.state.name")}>
                        <DBInput
                            type="text"
                            size="large"
                            value={language.name}
                            onChange={(e) =>
                                setLanguage({
                                    ...language,
                                    name: e.target.value,
                                })
                            }
                        />
                    </DBFieldBlock>

                    <DBFieldBlock title={t("criteria.state.language")}>
                        <DBSelect
                            value={language.language}
                            onChange={(e) =>
                                setLanguage({
                                    ...language,
                                    language: e,
                                })
                            }
                            options={[
                                {
                                    value: "en",
                                    label: getLanguageCaption("en"),
                                },
                                {
                                    value: "ar",
                                    label: getLanguageCaption("ar"),
                                },
                            ]}
                            size="large"
                        />
                    </DBFieldBlock>

                    <DBFieldBlock title="" span={2}>
                        <DBButton
                            disabled={!language.name}
                            caption={
                                languageEditMode === false
                                    ? t("items.add.language")
                                    : t("items.edit.language")
                            }
                            className="fullwidth-button"
                            outlined
                            onClick={addLanguageHandle}
                        />
                    </DBFieldBlock>
                </div>
                {form.translates.length > 0 && (
                    <div className="language-table">
                        <StateLanguageTable
                            data={form.translates.map((item) => ({
                                ...item,
                                language:
                                    item.language === "en"
                                        ? t("item.type.language.en")
                                        : t("item.type.language.ar"),
                            }))}
                            onEdit={editLanguageHandle}
                            onDelete={deleteLanguageHandle}
                        />
                    </div>
                )}
            </DBModal.Content>
            <DBModal.Footer>
                <DBButton caption={t("save")} onClick={addEditState} />
                <DBButton
                    caption={t("cancel")}
                    type="secondary"
                    onClick={onHide}
                />
            </DBModal.Footer>
        </DBModal>
    );
}
